<template>
  <ZMainPage :loading="loading" type="card">
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">报名信息</span>
      </div>
      <LineWrapper column="3" label-width="160rem" list>
        <LineItem v-for="item in list1" :key="item.label" :label="item.label" :value="item.value"></LineItem>
      </LineWrapper>
    </div>
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text mr-2">缴费信息</span>
        <span class="tags-wrap">
          <span v-for="i in pre_pay_msg" class="item">{{ i }}</span>
        </span>
      </div>
      <template v-if="isDetail">
        <template v-if="approve_status === 2">
          <LineWrapper column="3" list>
            <LineItem v-for="item in list2" :key="item.label" :cssStyle="item.cssStyle" :label="item.label" :value="item.value" class="item" />
          </LineWrapper>
        </template>
        <template v-else>
          <LineWrapper column="3" list>
            <LineItem v-for="item in list2" :key="item.label" :cssStyle="item.cssStyle" :label="item.label" :value="item.value" class="item" />
          </LineWrapper>
          <LineWrapper v-if="paid_amount" column="3" labelWidth="160rem" list>
            <LineItem label="实缴金额及方式">
              <div style="width: 700rem;">
                <CustomTable :config="config" :data="data" type="gray"/>
                <ZuTips :value="sumAmountDetail" class="mt-2" showIcon type="info"/>
              </div>
            </LineItem>
          </LineWrapper>
          <LineWrapper v-if="remarks" labelWidth="160rem">
            <LineItem :value="remarks" label="备注"></LineItem>
          </LineWrapper>
        </template>
      </template>
      <el-form v-else ref="form1" :model="formData" :rules="rules" label-position="left" label-width="200rem">
        <el-row>
          <el-col span="8">
            <el-form-item label="应缴金额" prop="sum_compute_price">
              <el-input v-model="formData.sum_compute_price" placeholder="请输入应缴金额" @input="onPaymentChange"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="是否分期" prop="is_by_stages">
              <el-select v-model="formData.is_by_stages" placeholder="请选择是否分期" @change="onStageChange">
                <el-option :value="0" label="否"></el-option>
                <!-- <el-option :value="1" label="是"></el-option> -->
                <el-option :value="2" label="部分欠缴"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="8">
            <el-form-item label="已缴金额" prop="payment_amount">
              <el-input v-model="formData.payment_amount" :placeholder="`请输入${formData.is_by_stages ? '已' : '应'}缴金额`" :disabled="!formData.is_by_stages" @input="onPaymentAmountChange"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="formData.is_by_stages" span="8">
            <el-form-item label="欠缴金额">
              <el-input v-model="formData.sum_remain_price" placeholder="请输入已缴金额" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="z-no-margin-bottom mb-2" label="实缴金额及方式" v-if="String(formData.payment_amount) !== '0'">
          <div v-for="(domain, index) in formData.payment_detail" :key="domain.id" class="z-dynamic-list-item">
            <div class="flex z-dynamic-list-inner">
              <el-form-item :prop="`payment_detail.${index}.paid_amount`" :rules="dynamicNumber" labelWidth="0">
                <el-input v-model="domain.paid_amount" placeholder="请输入学生缴费金额"></el-input>
              </el-form-item>
              <div class="px-2 text-gray">-</div>
              <el-form-item :prop="`payment_detail.${index}.payment_method`" :rules="dynamicSelect" labelWidth="0">
                <el-select v-model="domain.payment_method" placeholder="请选择学生缴费方式">
                  <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <div class="px-2 text-gray">-</div>
              <el-form-item :prop="`payment_detail.${index}.payer`" :rules="dynamicInput" labelWidth="0">
                <el-input v-model="domain.payer" maxlength="20" placeholder="请输入付款人姓名"></el-input>
              </el-form-item>
              <div class="px-2 text-gray">-</div>
              <el-form-item :prop="`payment_detail.${index}.payment_at`" :rules="dynamicDate" labelWidth="0">
                <el-date-picker v-model="domain.payment_at" placeholder="请选择缴费时间" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </el-form-item>
            </div>
            <el-form-item label-width="40rem">
              <el-button v-if="formData.payment_detail.length !== 1" circle icon="el-icon-delete" @click.prevent="handelRemove(domain)"></el-button>
              <el-button
                  v-if="formData.payment_detail.length !== dynamicMaxlength && index === formData.payment_detail.length - 1"
                  circle
                  icon="el-icon-plus"
                  @click="handleAdd"></el-button>
            </el-form-item>
          </div>
          <ZuTips :value="sumAmount" showIcon type="info"/>
        </el-form-item>
        <el-row>
          <el-col span="15">
            <el-form-item label="备注">
              <el-input v-model="formData.remarks" maxlength="300" placeholder="请输入" rows="8" show-word-limit type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-if="isShowContract && formDataMu.student_type_id ===1" class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text mr-2">协议签署</span>
      </div>
      <el-form ref="signingRef" :model="formData" :rules="rules" label-position="left" label-width="200rem">
        <el-row>
          <el-col span="24" style="display:grid;grid-template-columns: repeat(3, 1fr)">
            <el-form-item v-if="approve_status === 0" label="是否需要签约">
              <span>
                <el-radio v-model="formData.is_need_sign" :label="1">需要签约</el-radio>
                <el-radio v-model="formData.is_need_sign" :label="0">无需签约</el-radio>
              </span>
            </el-form-item>
            <el-form-item v-if="approve_status !== 0" label="是否需要签约">
              {{ formDataMu.is_need_sign_text }}
            </el-form-item>
            <el-form-item v-if="approve_status !== 0 && formDataMu.is_need_sign_text !== '无需签约'" label="签约状态">
              {{ formDataMu.sign_status }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item 
          v-if="(approve_status === 0 && formData.is_need_sign === 1) || (approve_status !== 0 && formDataMu.is_need_sign_text !== '无需签约')"
          :label="approve_status === 0 ? '应签合同' : '需签署合同'"
          class="z-no-margin-bottom mb-2" prop="contract_template_objs">
          <el-button v-if="approve_status === 0" style="margin-bottom: 12px" @click="classDialogShow=true">点击选择</el-button>
          <div>
            <el-tag v-for="i in formData.contract_template" :key="i" style="margin-right: 12px" type="info">
              {{ classOptions.find(item => item.template_id_name === i)?.template_name }}
            </el-tag>
            <el-tag v-for="i in formDataMu.sign_contract" :key="i" style="margin-right: 12px" type="info">
              {{ i }}
            </el-tag>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">操作记录</span>
      </div>
      <LineWrapper column="3" list>
        <LineItem v-for="item in list3" :key="item.label" :cssStyle="item.cssStyle" :label="item.label" :value="item.value" class="item"></LineItem>
      </LineWrapper>
    </div>
    <Dialog :beforeSubmit="onBeforeClose" :visible.sync="visible" showLine title="驳回原因">
      <el-form ref="form2" :model="formData" :rules="rules" label-position="left" label-width="0">
        <el-form-item prop="reject_reason">
          <el-input v-model="formData.reject_reason" :autosize="{ minRows: 4, maxRows: 8}" :maxlength="100" placeholder="请输入" show-word-limit type="textarea"></el-input>
        </el-form-item>
        <ZuTips showIcon type="info" value="驳回后所更改内容不会保存，请谨慎操作！"/>
      </el-form>
    </Dialog>
    <Dialog :showFooter="false" :visible.sync="visible2" showLine title="历史记录">
      <TimeLine :list="list4" :loading="dialogLoading" reverse></TimeLine>
    </Dialog>
    <Dialog :visible.sync="classDialogShow" custom-class="transfer" title="选择合同" width="60%" @close="onClassDialogClose">
      <div>
        <el-transfer v-model="formData.contract_template" :data="classOptions" :left-default-checked="leftCheckedKeys" :props="{
              key: 'template_id_name',
              label: 'template_name'
            }"
            :titles="['待选区', '已选区']" filter-placeholder="请输入" filterable=""
            @change="onContractChange">
        </el-transfer>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClassDialogClose">取 消</el-button>
        <el-button type="primary" @click="onClassHandle">确 定</el-button>
      </span>
    </Dialog>
    <template #footer>
      <template v-if="isDetail">
        <el-button type="primary" @click="handleHistory">查看历史记录</el-button>
        <el-button @click="handleBack">返回</el-button>
      </template>
      <template v-else-if="isEdit">
        <el-button type="primary" @click="handleSubmit(true)">保存</el-button>
        <el-button @click="handleBack">返回</el-button>
      </template>
      <template v-else>
        <el-button type="primary" @click="handleSubmit(false)">通过</el-button>
        <el-button type="danger" @click="handleCancel">驳回</el-button>
        <el-button @click="handleBack">返回</el-button>
      </template>
    </template>
  </ZMainPage>
</template>
<script>
import Dialog from '@/components/common/Dialog'
import LineWrapper from '@/components/common/LineWrapper'
import LineItem from '@/components/common/LineItem'
import ZuTips from '@/components/common/ZuTips'
import CustomTable from '@/components/common/CustomTable'
import TimeLine from '@/components/common/TimeLine'
import http, {zs_opt_history} from '@/api'
import { formatDate, transformAddOrEditData, objectIsEmpty, preciseAdd, preciseSubtract } from '@/utils'
import { validateNumber, verifyIsNumber } from '@/utils/validate'
import {orderPayMethod} from '@/utils/data'

export default {
  _config: {
    'route': [{'path': 'detail', 'meta': {'title': '查看'}}, {
      'path': 'approve',
      'meta': {'title': '审批'}
    }, {'path': 'edit', 'meta': {'title': '编辑'}}]
  },
  components: {Dialog, LineWrapper, LineItem, ZuTips, CustomTable, TimeLine},
  data() {
    const v1 = (_r, value, callback) => {
      const v = String(value)
      if (this.formData.is_by_stages && v === '0') {
        return callback(new Error('应缴金额应当大于0'))
      }
      return validateNumber(value, callback)
    }
    const v2 = (_r, value, callback) => {
      if (!this.formData.is_by_stages) return callback()
      const v = verifyIsNumber(value, { empty: '请输入已缴金额', positive: true  })
      if (v) return callback(new Error(v))
      const n1 = Number(this.formData.sum_compute_price)
      validateNumber(value, callback, { min: 0, max: n1, equalToMin: true })
    }
    return {
      loading: false,
      isDetail: false,
      isEdit: false,
      visible: false,
      visible2: false,
      dialogLoading: false,
      classDialogShow: false,
      isShowContract: false,
      id: '',
      approve_status: '',
      student_name: '',
      pre_pay_msg: [],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      config: [],
      data: [],
      classOptions: [],
      classList: [],
      sumAmountDetail: '',
      sum_compute_price: '',
      remarks: '',
      paid_amount: 0,
      formData: {
        sum_compute_price: '',
        is_by_stages: 0,
        payment_amount: '',
        sum_remain_price: '',
        payment_detail: [],
        contract_template: [],
        contract_template_objs: [],
        remarks: '',
        reject_reason: '',
        is_need_sign: 1,
      },
      rules: {
        reject_reason: [{required: true, message: '请输入', trigger: 'change'}],
        is_by_stages: [{required: true, message: '请选择是否分期', trigger: 'change'}],
        sum_compute_price: [{ required: false, validator: v1, trigger: 'change' }],
        payment_amount: [{ required: false, validator: v2, trigger: 'change' }],
        contract_template_objs:  [{
          required: true,
          validator: (_, value, callback) => {
            if (value.length) {
              return callback()
            }
            this.$message.error({ message: '请选择需签署的合同！', duration: 4000 })
            callback(new Error('请选择需签署的合同！'))
          },
          trigger: 'change'
        }]
      },
      typeOptions: [],
      dynamicMaxlength: 15,
      dynamicSelect: {required: true, message: '请选择学生缴费方式', trigger: 'change'},
      dynamicInput: {required: true, message: '请输入付款人姓名', trigger: 'blur'},
      dynamicDate: {required: true, message: '请选择缴费时间', trigger: 'change'},
      dynamicNumber: {
        required: true,
        validator: (_, value, callback) => validateNumber(value, callback, {
          min: 0,
          equalToMin: true,
          empty: '请输入学生缴费金额'
        }),
        trigger: 'blur'
      },
      formDataMu: {},
      leftCheckedKeys: []
    }
  },
  computed: {
    sumAmount() {
      const arr = this.formData.payment_detail.filter(i => i.paid_amount)
      const sum = arr.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount) || 0), 0)
      if (isNaN(sum)) return '请输入数字'
      return `累计实缴金额：${sum}`
    }
  },
  created() {
    const id = this.$route.query.id
    this.id = id
    if (this.$route.path.includes('detail')) {
      this.isDetail = true
    } else if (this.$route.path.includes('edit')) {
      this.isEdit = true
    }
    this.getData(id)
    this.getConfig()
  },
  methods: {
    getConfig() {
      this.typeOptions = orderPayMethod()
    },
    onStageChange(val) {
      if (val) {
        this.formData.payment_amount = ''
        this.formData.sum_remain_price = ''
      } else {
        this.formData.payment_amount = this.formData.sum_compute_price
      }
      this.rules.payment_amount[0].required = !!val
      this.$nextTick(() => {
        this.$refs.form1.clearValidate('payment_amount')
      })
    },
    changePriceData(val) {
      const v = verifyIsNumber(val, { empty: '请输入已缴金额', positive: true  })
      if (v) {
        this.formData.sum_remain_price = ''
        return
      }
      const v1 = Number(this.formData.sum_compute_price)
      const v2 = Number(val)
      if (v2 <= 0 || v2 >= v1) {
        this.formData.sum_remain_price = v2 === 0 ? v1 : ''
        return
      }
      const v3 = preciseSubtract(v1, v2)
      this.formData.sum_remain_price = v3
    },
    onPaymentChange(val) {
      if (!this.formData.is_by_stages) {
        this.formData.payment_amount = val
        return
      }
      if (this.formData.payment_amount) {
        this.$refs.form1.validateField('payment_amount')
        this.changePriceData(this.formData.payment_amount)
      }
    },
    onPaymentAmountChange(val) {
      this.changePriceData(val)
    },
    getData(id) {
      this.loading = true
      http({url: `/recruit-v2/approve-fresh/detail-v2?id=${id}`, pre: 'zs'}).then(res => {
        const {history = {}, payment_detail = []} = res
        this.isShowContract = res.year < 2026
        this.formDataMu = res
        this.approve_status = res.approve_status
        this.student_name = res.student_name
        this.pre_pay_msg = res.pre_pay_msg || []
        this.list1 = [
          {label: '报名校区', value: res.school_name},
          {label: '入学年级', value: res.grade_name},
          {label: '入学年份', value: res.grade_year},
          {label: '学生姓名', value: res.student_name},
          {label: '学生身份证号/护照号', value: res.student_idcard},
          {label: '学生类型', value: res.student_type},
          {label: '所属业务线', value: res.business_line},
        ]
        this.formData.sum_compute_price = res.payment_amount
        if (this.isDetail) {
          if (res.approve_status === 1) {
            this.paid_amount = Number(res.paid_amount)
            this.data = payment_detail
            this.config = [
              {prop: 'paid_amount', label: '学生缴费金额', type: 'other'},
              {prop: 'payment_method', label: '学生缴费方式', type: 'other'},
              {prop: 'payer', label: '付款人姓名', type: 'other'},
              {prop: 'payment_at', label: '缴费时间', type: 'other'}
            ]
            const sum = payment_detail.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount) || 0), 0)
            this.sumAmountDetail = `累计实缴金额：${sum}`
            const arr = ['否', '是', '部分欠缴']
            const list = [
              { label: '应缴金额', value: res.payment_amount },
              { label: '是否分期', value: arr[res.is_by_stages], cssStyle: {'grid-column': '2 / -1' }},
              { label: '已缴金额', value: res.paid_amount }
            ]
            if (res.is_by_stages) {
              list.push({label: '欠缴金额', value: res.remain_amount, cssStyle: {'grid-column': '2 / -1'}})
            }
            this.list2 = list
            if (res.remarks) {
              this.remarks = res.remarks
            }
          } else {
            const list = [
              {label: '应缴金额', value: res.payment_amount},
            ]
            if (res.remarks) {
              list.push({label: '备注', value: res.remarks, cssStyle: {'grid-column': '1 / -1'}})
            }
            this.list2 = list
          }
        } else if (this.isEdit) {
          const id = Date.now()
          this.formData.is_by_stages = res.is_by_stages
          this.formData.payment_amount = res.paid_amount
          this.formData.sum_remain_price = res.remain_amount
          this.formData.remarks = res.remarks
          if (payment_detail.length) {
            if (Number(res.paid_amount)) {
              this.formData.payment_detail = payment_detail.map((i, j) => {
                return {
                  id: id + j,
                  payment_method: i.payment_method,
                  paid_amount: i.paid_amount,
                  payer: i.payer,
                  payment_at: i.payment_at
                }
              })
            } else { 
              this.formData.payment_detail.push({
                id,
                payment_method: '',
                paid_amount: '',
                payer: '',
                payment_at: res.pay_time
              })
            }
            
          } else {
            this.formData.payment_detail.push({
              id,
              payment_method: '',
              paid_amount: '',
              payer: '',
              payment_at: res.pay_time
            })
          }
        } else {
          this.formData.payment_amount = res.payment_amount
          this.formData.remarks = res.remarks
          this.formData.payment_detail.push({
            id,
            payment_method: '',
            paid_amount: '',
            payer: '',
            payment_at: res.pay_time
          })
        }
        const list = [
          {label: '录入人', value: history.creator},
          {label: '录入时间', value: history.created_at, cssStyle: {'grid-column': '2 / -1'}}
        ]
        if (history.approve_status === '待审批') {
          list.push({label: '审批状态', value: history.approve_status})
        } else {
          list.push({label: '审批人', value: history.approve_user})
          list.push({label: '审批时间', value: history.approve_at, cssStyle: {'grid-column': '2 / -1'}})
          list.push({label: '审批状态', value: history.approve_status})
          if (history.approve_status === '已驳回') {
            list.push({label: '驳回原因', value: history.reject_reason, cssStyle: {'grid-column': '1 / -1'}})
          }
        }
        this.list3 = list

        http({
          url: '/recruit-v3/dict/contract-template-config',
          pre: 'zs',
          method: "get"
        }, {school_id: res.school_id, year: res.grade_year, student_type: res.student_type_id}).then(res => {
          this.classOptions = res
          // 初始化左侧待选区默认勾选项（不移动到右侧）
          this.leftCheckedKeys = (this.classOptions || [])
              .filter(i => i && i.template_id_name === 'main_template_id')
              .map(i => i.template_id_name)
          // 同步一次选中项的完整对象
          this.onContractChange(this.formData.contract_template)
        })
      }).finally(() => {
        this.loading = false
      })
    },
    onContractChange(newKeys) {
      const keyField = 'template_id_name'
      const set = new Set(newKeys || [])
      this.formData.contract_template_objs = (this.classOptions || [])
          .filter(item => set.has(item[keyField]))
          .map(item => {
            const {template_name, ...rest} = item
            return rest
          })
    },
    handleHistory() {
      this.visible2 = true
      this.list4 = []
      this.dialogLoading = true
      zs_opt_history({type: 'formal_information', id: this.id}).then(res => {
        const {list} = res
        this.list4 = list.map(i => ({content: i.change_detail}))
      }).finally(() => this.dialogLoading = false)
    },
    handleBack() {
      this.$router.back()
    },
    handleCancel() {
      this.visible = true
    },
    onHttp(data, edit = false) {
      return new Promise((resolve, reject) => {
        http({
          url: `/recruit-v2/approve-fresh/${edit ? 'edit' : 'approve-v2'}`,
          method: 'post',
          pre: 'zs'
        }, data).then(() => {
          let msg = `${data.approve_status === 1 ? '审批通过' : '驳回成功'}！`
          if (edit) msg = '编辑成功！'
          this.$message.success(msg);
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    onBeforeHttp(edit) {
      const arr = this.formData.payment_detail.filter(i => i.paid_amount)
      const sum = arr.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount)), 0)
      const total = Number(this.formData.sum_compute_price)
      const actual = Number(this.formData.payment_amount)
      let msg = ''
      if (actual) {
        if ((this.formData.is_by_stages && actual !== sum) || (!this.formData.is_by_stages && total !== sum)) {
          msg = '学生【实缴金额及方式】的累计实缴金额需等于【已缴金额}】'
        }
      }
      // if (total !== sum) msg = `学生【实缴金额及方式】的累计实缴金额需等于【应缴金额】`
      if (msg) return this.$message.error({message: msg, duration: 4000})
      const { sum_compute_price, payment_amount, sum_remain_price, payment_detail, reject_reason, is_need_sign, contract_template,  contract_template_objs, ...os } = this.formData
      const data = {id: this.id, sum_compute_price: Number(sum_compute_price), payment_amount: Number(payment_amount), is_need_sign: 0, contract_template: [], ...os}
      // 将提交的 contract_template 替换为完整对象数组
      if (this.isShowContract && this.formDataMu.student_type_id === 1) {
        data.is_need_sign = is_need_sign
        data.contract_template = this.formData.contract_template_objs
      }
      
      data.payment_detail = Number(payment_amount) ? transformAddOrEditData(payment_detail) : [
          {
            payment_method: '现金',
            paid_amount: 0,
            payer: '/',
            payment_at: formatDate().fullDateTime
          }
        ]
      if (data.is_by_stages === 2) {
        data.sum_remain_price = Number(sum_remain_price)
      } else {
        data.sum_remain_price = 0
      }
      if (this.isEdit) {
        data.paid_amount = Number(payment_amount)
      }
      if (edit) {
        return this.onHttp(data, true).then(() => {
          this.$router.back()
        })
      }
      this.$msgbox({
        title: '注意',
        message: `审批通过后家长无需缴费即可报名成功，是否确认【${this.student_name}】的应缴金额无误？`,
        showCancelButton: true,
        confirmButtonText: '通过审批',
        cancelButtonText: '再看看',
        beforeClose: (action, instance, done) => {
          if (instance.confirmButtonLoading) return
          if (action !== 'confirm') return done()
          instance.confirmButtonLoading = true
          instance.confirmButtonText = '执行中...'
          data.approve_status = 1
          this.onHttp(data).then(() => {
            done()
            this.$router.back()
          }).finally(() => {
            instance.confirmButtonText = '通过审批'
            instance.confirmButtonLoading = false
          })
        }
      })
    },
    handleSubmit(edit = false) {
      this.$refs.form1.validate((valid1) => {
        if (!this.$refs.signingRef) {
          if (!valid1) return
          return this.onBeforeHttp(edit)
        }
        this.$refs.signingRef.validate((valid2) => {
          if (valid1 && valid2) {
            this.onBeforeHttp(edit)
          }
        })
      })
    },
    onBeforeClose(done, instance) {
      this.$refs.form2.validate((valid) => {
        if (valid) {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '保存中...';
          const data = {reject_reason: this.formData.reject_reason, id: this.id, approve_status: 2}
          this.onHttp(data).then(() => {
            done()
            this.$router.back()
          }).finally(() => {
            instance.confirmButtonText = '确定'
            instance.confirmButtonLoading = false
          })
        }
      })
    },
    handleClear() {
      this.formData.payment_detail = []
      this.handleAdd()
    },
    handleAdd() {
      if (this.dynamicMaxlength <= this.formData.payment_detail.length) {
        return this.$message.warning(`最多只能添加${this.dynamicMaxlength}条`);
      }
      this.formData.payment_detail.push({
        id: Date.now(),
        payment_method: '',
        paid_amount: '',
        payer: '',
        payment_at: '',
        isAdd: 1
      })
    },
    handleDelete(item) {
      const index = this.formData.payment_detail.indexOf(item)
      if (!~index) return
      this.formData.payment_detail.splice(index, 1)
    },
    handelRemove(item) {
      const {id, ...other} = item
      if (objectIsEmpty(other, ['isAdd'])) return this.handleDelete(item)
      this.$confirm('此操作将删除该项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, _instance, done) => {
          if (action === 'confirm') this.handleDelete(item)
          done()
        }
      }).then(() => {
        this.$message({type: 'success', message: `删除成功!`})
      })
    },
    onClassDialogClose() {
      this.classDialogShow = false
    },
    onClassHandle() {
      if (!this.formData.contract_template || !this.formData.contract_template.length) {
        return this.$message.warning('请选择至少一个合同模板')
      }
      if (!this.formData.contract_template.includes('main_template_id')) {
        return this.$message.warning('请勾选【应届生入学协议】！')
      }
      this.classDialogShow = false
    }
  }
}
</script>
<style lang="scss" scoped>
.tags-wrap {
  display: inline-flex;
  gap: 10rem;

  .item {
    display: inline-block;
    padding: 2rem 6rem;
    background: #f0f0f0;
    border-radius: 4rem;
    font-size: 12rem;
    color: #666;

    &:nth-child(3n+1) {
      color: #45A3ED;
      background-color: #DDEFFF;
    }

    &:nth-child(3n+2) {
      color: #41D193;
      background-color: #DAF6EC;
    }

    &:nth-child(3n) {
      color: #F06638;
      background-color: #FDE5D4;
    }
  }
}

::v-deep(.el-transfer-panel) {
  width: 440rem;
}
</style>
